const theme = {
  primary: '#04d361',
  fontDark: '#3A3A3A',
};

export type TypeTheme = typeof theme;

export default theme;
